import UsersAPI from '../api/Users';
import JwtControllerApi from '../api/JwtController';
import * as ActionTypes from '../constants/ActionTypes';

export const showAuthModal = isShowAuthModal => ({
    type: ActionTypes.SHOW_AUTH_MODAL,
    payload: isShowAuthModal
});

export const showRegModal = isShowRegModal => ({
    type: ActionTypes.SHOW_REG_MODAL,
    payload: isShowRegModal
});

export const changeVisibleRestorePasswordFirstStep = showModal => ({
    type: ActionTypes.CHANGE_VISIBLE_RESTORE_PASSWORD_FIRST_STEP_MODAL,
    payload: showModal
});

export const changeVisibleRestorePasswordSecondStep = showModal => ({
    type: ActionTypes.CHANGE_VISIBLE_RESTORE_PASSWORD_SECOND_STEP_MODAL,
    payload: showModal
});

export const loginFacebook = accessToken => ({
    type: ActionTypes.LOGIN_FACEBOOK,
    payload: accessToken
});

export const loginEmail = (email, password, showErrorModal) => dispatch => {
    UsersAPI.emailLogin(email, password, showErrorModal)
        .then(({data: {token}}) => {
            dispatch({
                type: ActionTypes.LOGIN_EMAIL,
                payload: token
            });
        })
        .catch((error) => {
            if (error.response.status === 401) {
                dispatch({
                    type: ActionTypes.SHOW_WRONG_DATA_MESSAGE,
                    payload: true
                })
            }
        });
};

export const register = (email, password) => dispatch => {
    UsersAPI.register(email, password)
        .then(({data: {token}}) => {
            dispatch({
                type: ActionTypes.REGISTER,
                payload: token
            });
        });
};

export const logout = () => ({
    type: ActionTypes.LOGOUT,
    payload: null
});

export const changeFavorites = objectId => ({
    type: ActionTypes.CHANGE_FAVORITES,
    payload: objectId
});

export const setUserInfo = accessToken => ({
    type: ActionTypes.SET_USER_INFO,
    payload: accessToken
});


export const confirmEmailCode = (confirmationCode) => dispatch => {
    JwtControllerApi.confirmEmail(confirmationCode).then(({data: {token}}) => {
        dispatch({
            type: ActionTypes.REGISTER,
            payload: token
        });
    });
};

export const restorePasswordFirstStep = (email) => dispatch => {
    return JwtControllerApi.restoreEmailPasswordFirst(email)
}

export const restorePasswordSecondStep = (newPassword, key) => dispatch => {
    return JwtControllerApi.restoreEmailPasswordSecond(key, newPassword)
}


// WEBPACK FOOTER //
// ./src/actions/User.js